import dva from 'dva';
//import dynamic from 'dva/dynamic';
import { message } from 'antd';
import { browserHistory } from 'dva/router';
import createHistory from 'history/createBrowserHistory';
import coreModel from './core';
//import {Lang} from './DimioLibrary';
//import _ from 'lodash';

/**
 *
 * @param opt
 *  id: target dom id
 *  key: model key (id)
 * @constructor
 */
const InitApp = (opt) => {
  const id = '#'+opt.id;
  const ds = Object.assign({}, opt.dataset);

  if (id === undefined || ds.key === undefined) {
    throw "Dom container id or data-key is not set properly";
  }

  // set initial values
  const key = ds.key;
  delete ds.key;
  const model = (ds.model)?ds.model:key;
  delete ds.model;
//  const test = (ds.test)?Boolean(ds.test):false;
  const test = (ds.test)?parseInt(ds.test):0;
  delete ds.test;
  const ready = (ds.ready)?Boolean(parseInt(ds.ready)):true;
  delete ds.ready;

  const initialState = {
    'core': {
      key: key,
      model: model,
      test: test,
      defaultValues: ds,
      ready: ready,   // checking rendering ready or not
      trans: null     // translation key files
    }
  };

  // 1. Initialize
  const app = dva({
    history: createHistory(),
    initialState: initialState,
    onError(e) {
      console.error(e);
//      alert(e.message);
      message.error(e.message, 3);
    },
  });

  console.info(`[${opt.id}]`, ds);

//  app.xx = (x) => {console.info(x)};

  // 2. Plugins
  //app.use(createLoading());

//  const core = Object.assign(coreModel, {})

  // 3. Model
  // set core model
  app.model(coreModel);

  // set specified model
  app.model(require(`../pages/${key}/models/${model}`).default);
  console.info('model:', `../pages/${key}/models/${model}`);

  // 4. router
  app.router(require(`../pages/${key}/config/router`).default);

  // 5. Start
  app.start(id);

  /*
  const UserPageComponent = dynamic({
    app,
    models: () => [
      import(`../pages/${ds.key}/models/${ds.key}`),
    ],
    //component: () => import(`../pages/${ds.key}/config/router`),
  });
*/


};

export default InitApp;



// WEBPACK FOOTER //
// ./src/lib/InitApp.js